import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const jeli = defineConnector({
  identifier: "jeli",
  name: "Jeli",
  tagLine: "Incident analysis",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://api\\.jeli\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Generate an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Jeli, navigate to **Settings → API Tokens** and click **Generate token**. Enter a meaningful name for the token.",
        },
      ],
    },
    {
      title: "Paste your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.jeli.io/api/v1/incidents",
  },
});
